
























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

@Component({})
export default class ConfirmModal extends Vue {
  private eventEmit = {
    eventCloseModal: 'eventCloseModal',
    eventAcceptModal: 'eventAcceptModal',
    eventOtherModal: 'eventOtherModal'
  };

  @Prop({default: false})
  private isShowModal!: boolean;

  @Prop({default: ''})
  private content!: string;

  @Prop({default: true})
  public showNextButton!: boolean;
  
  @Prop({default: true})
  public showCloseButton!: boolean;
  
  @Prop({default: false})
  public showOtherButton!: boolean;

  @Prop({default: 'Tiếp tục'})
  public nextButtonText!: string;

  @Prop({default: 'Nạp ví'})
  public otherButtonText!: string;

  private async created() {
    document.documentElement.style.overflow = 'hidden';
  }

  private onClose() {
      document.documentElement.style.overflow = 'auto';
      this.$emit(this.eventEmit.eventCloseModal, {
        data: null,
        close: true
      });
  }

  private onAccept() {
    document.documentElement.style.overflow = 'auto';
    this.$emit(this.eventEmit.eventAcceptModal, {
        data: 'OK',
        close: true
    });
  }
  
  private onOtherAction() {
    document.documentElement.style.overflow = 'auto';
    this.$emit(this.eventEmit.eventOtherModal, {
        data: 'OK',
        close: true
    });
  }
}
